import { TableColumnType, TableProps } from 'antd'
import { ParamKey } from 'shared/types/QueryModel'

import { Table } from 'shared/ui/Table'

import { useTable } from '../../hooks/useTable'
import HeaderWithFilters, { HeaderWithFiltersProps } from '../HeaderWithFilters'

interface Props<T> extends TableProps<any> {
  columns: TableColumnType<T>[]
  filterParams?: ParamKey[]
  className?: string
  onRow?: TableProps<any>['onRow']
  apiUrl?: string
  headerFiltersProps?: HeaderWithFiltersProps
  total?: number
  skipQuery?: boolean
}

const AppTable = <T,>({
  columns,
  filterParams,
  className,
  onRow,
  apiUrl,
  headerFiltersProps,
  total,
  skipQuery,
  ...props
}: Props<T>) => {
  const { totalCount, preparedTableData, isFetching } =
    useTable({
      apiUrl,
      filterParams,
      skipQuery,
    }) || {}
  if (headerFiltersProps) {
    return (
      <div className="mt-[20px] border border-light_gray_3 rounded-[16px] overflow-hidden">
        <HeaderWithFilters
          {...headerFiltersProps}
          tableCount={totalCount ?? total ?? 0}
        />
        <Table<T>
          loading={isFetching}
          columns={columns}
          dataSource={preparedTableData || []}
          scroll={{ x: 1150 }}
          total={totalCount ?? total ?? 0}
          filterParams={filterParams}
          className={className}
          onRow={onRow}
          {...props}
        />
      </div>
    )
  }
  return (
    <Table<T>
      loading={isFetching}
      columns={columns}
      dataSource={preparedTableData || []}
      scroll={{ x: 1150 }}
      total={totalCount ?? total ?? 0}
      filterParams={filterParams}
      className={className}
      onRow={onRow}
      {...props}
    />
  )
}

export default AppTable
